import React from "react";
import Footer from "./footer";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";

function Contact() {
  const { t } = useTranslation("contact");
  ReactGA.pageview(window.location.pathname + window.location.search);
  //return(<IssuesInbox/>)
  return (
    <div>
      <section id="contact" className="contact">
        <div className="container align-items-center">
          <div className="row mt-5">
            <div
              className="col-lg-4"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="info">
                <div className="address">
                  <i className="bi bi-geo-alt"></i>
                  <h4>{t("Location")}</h4>
                  <p> {t("Address")}</p>
                </div>

                <div className="email">
                  <i className="bi bi-envelope"></i>
                  <h4>{t("Email")}</h4>
                  <p>gis.helpdesk@mun.rak.ae</p>
                </div>

                <div className="phone">
                  <i className="bi bi-phone"></i>
                  <h4>{t("Call")}</h4>
                  <p style={{ direction: "ltr" }}>+971 7 246 6666</p>
                </div>
              </div>
            </div>
            <div className="col-lg-8 mt-5 mt-lg-0">
              <iframe
                style={{ border: 0, width: "100%", height: "400px" }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d388258.4322690605!2d55.81278480715158!3d25.741794137871416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef673fffcd3b517%3A0x8858e503331a039f!2sRas%20Al%20Khaimah%20Municipality%20Department!5e0!3m2!1sen!2sae!4v1620018329288!5m2!1sen!2sae"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>

            {/* <div className="col-lg-8 mt-5 mt-lg-0"> */}
            {/* <form
                action="forms/contact.php"
                method="post"
                role="form"
                className="php-email-form"
              >
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                </div>
                <div className="form-group mt-3">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    id="subject"
                    placeholder="Subject"
                    required
                  />
                </div>
                <div className="form-group mt-3">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="5"
                    placeholder="Message"
                    required
                  ></textarea>
                </div>
                <div className="my-3">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">
                    Your message has been sent. Thank you!
                  </div>
                </div>
                <div className="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form> */}
            {/* </div> */}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Contact;
